const KEY_AUTH = 'mochi_auth';
const KEY_SKIP_LOGIN = 'skip_login';
const KEY_CPCPAY_ID = 'cpcpay_id';
const KEY_MOBILE = 'mobile';
const KEY_MOCHI_CLIENT_HAS_BEEN_LOGIN = 'mochi_client_has_been_login';
const KEY_LINE_BANK_IS_BINDED = 'line_bank_is_binded';
const KEY_IKNOW99_IS_BINDED = 'iknow99_is_binded';
const KEY_HAS_CHECKED_SERVICES = 'has_checked_service_instruction';
const KEY_RICHART_LIFE_IS_BINDED = 'richart_life_is_binded';

class Storage {
  #user;

  getHasCheckedServiceInstruction = () => {
    return localStorage.getItem(KEY_HAS_CHECKED_SERVICES) || false;
  };

  saveHasCheckedServiceInstruction = () => {
    return localStorage.setItem(KEY_HAS_CHECKED_SERVICES, true);
  };

  getMochiClientHasBeenLogin = () => {
    return localStorage.getItem(KEY_MOCHI_CLIENT_HAS_BEEN_LOGIN) || false;
  };

  saveMochiClientHasBeenLogin = () => {
    return localStorage.setItem(KEY_MOCHI_CLIENT_HAS_BEEN_LOGIN, true);
  };

  getRichartLifeIsBinded = () => {
    return localStorage.getItem(KEY_RICHART_LIFE_IS_BINDED) || false;
  };

  saveRichartLifeIsBinded = () => {
    return localStorage.setItem(KEY_RICHART_LIFE_IS_BINDED, true);
  };

  getLineBankIsBinded = () => {
    return localStorage.getItem(KEY_LINE_BANK_IS_BINDED) || false;
  };

  saveLineBankIsBinded = () => {
    return localStorage.setItem(KEY_LINE_BANK_IS_BINDED, true);
  };

  clearLineBankIsBinded = () => {
    return localStorage.removeItem(KEY_LINE_BANK_IS_BINDED);
  };

  getIknow99IsBinded = () => {
    return localStorage.getItem(KEY_IKNOW99_IS_BINDED) || false;
  };

  saveIknow99IsBinded = () => {
    return localStorage.setItem(KEY_IKNOW99_IS_BINDED, true);
  };

  skipLogin = () => {
    return localStorage.setItem(KEY_SKIP_LOGIN, true.toString());
  };

  getSkipLogin = () => {
    if (this.isServer()) return;

    return localStorage.getItem(KEY_SKIP_LOGIN) || false;
  };

  clearSkipLogin = () => {
    if (this.isServer()) return;
    return localStorage.removeItem(KEY_SKIP_LOGIN);
  };

  saveAuth = (obj) => {
    return localStorage.setItem(KEY_AUTH, JSON.stringify(obj));
  };

  getAuth = () => {
    if (this.isServer()) return;

    return this.parse(localStorage.getItem(KEY_AUTH));
  };

  clearAuth = () => {
    if (this.isServer()) return;

    return localStorage.removeItem(KEY_AUTH);
  };

  getUser = () => {
    if (this.isServer()) return;

    return this.user;
  };

  saveUser = (obj) => {
    this.user = obj;
  };

  // cpcpay

  saveCpcpayId = (id) => {
    sessionStorage.setItem(KEY_CPCPAY_ID, id);
  };

  getCpcpayId = () => {
    return sessionStorage.getItem(KEY_CPCPAY_ID);
  };

  // citimkt

  saveMobile = (mobile) => {
    localStorage.setItem(KEY_MOBILE, mobile);
  };

  getMobile = () => {
    if (this.isServer()) return '';
    return localStorage.getItem(KEY_MOBILE);
  };

  isServer = () => {
    return typeof window === 'undefined';
  };

  parse = (obj) => {
    try {
      return JSON.parse(obj);
    } catch (e) {
      return null;
    }
  };
}

export default new Storage();
